import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { useI18n } from "../../i18n";
import { api, apiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";

export default function ChangePassword() {
  const { t } = useI18n();
  const nav = useNavigate();
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [cf, setCf] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nw.length < 8) { toast.error(t("cp_hint")); return; }
    if (nw !== cf) { toast.error(t("cp_mismatch")); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success(t("cp_success"));
      setCur(""); setNw(""); setCf("");
      nav("/app");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto space-y-5 gc-fade-up" data-testid="change-password-page">
      <div className="flex items-center gap-2.5">
        <div className="h-9 w-9 rounded-lg bg-[hsl(217_63%_15%)] text-white flex items-center justify-center">
          <ShieldCheck className="h-5 w-5" />
        </div>
        <h1 className="font-display text-2xl font-bold text-[hsl(217_63%_15%)]">{t("cp_title")}</h1>
      </div>
      <form onSubmit={submit} className="rounded-2xl border border-border bg-card p-6 space-y-4 shadow-sm">
        <div className="space-y-1.5">
          <label className="text-sm font-medium text-foreground/80">{t("cp_current")}</label>
          <Input data-testid="cp-current" type="password" value={cur}
            onChange={(e) => setCur(e.target.value)} required autoComplete="current-password" />
        </div>
        <div className="space-y-1.5">
          <label className="text-sm font-medium text-foreground/80">{t("cp_new")}</label>
          <Input data-testid="cp-new" type="password" value={nw}
            onChange={(e) => setNw(e.target.value)} required autoComplete="new-password" />
          <p className="text-xs text-muted-foreground">{t("cp_hint")}</p>
        </div>
        <div className="space-y-1.5">
          <label className="text-sm font-medium text-foreground/80">{t("cp_confirm")}</label>
          <Input data-testid="cp-confirm" type="password" value={cf}
            onChange={(e) => setCf(e.target.value)} required autoComplete="new-password" />
        </div>
        <Button data-testid="cp-submit" type="submit" disabled={busy} className="w-full rounded-full">
          <Lock className="h-4 w-4 me-1" /> {t("cp_submit")}
        </Button>
      </form>
    </div>
  );
}
